import PropTypes from "prop-types";

function Feature({ icon: Icon, iconBg, heading, text }) {
  return (
    <div
      className="d-flex align-items-start gap-3"
      style={{ maxWidth: "450px", padding: "10px" }}
    >
      <div
        className="d-flex align-items-center justify-content-center rounded-circle text-white"
        style={{
          width: "65px",
          height: "65px",
          backgroundColor: iconBg,
          flexShrink: 0,
        }}
      >
        <Icon size={28} />
      </div>
      <div style={{ flex: 1, textAlign: "left" }}>
        <h3
          className="fw-bold mb-2"
          style={{ fontSize: "18px", color: "#000" }}
        >
          {heading}
        </h3>
        <p
          className="text-muted m-0"
          style={{ fontSize: "15px", lineHeight: "1.5" }}
        >
          {text}
        </p>
      </div>
    </div>
  );
}

Feature.propTypes = {
  icon: PropTypes.elementType.isRequired,
  iconBg: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default Feature;
